import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
        tries += 1;
        if (tries > 15) {
          setState("pending");
          return;
        }
        timer = setTimeout(poll, 2000);
      } catch {
        setState("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center px-6" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-2xl border-2 border-[#F5F2EB] bg-[#141414] p-10 text-center shadow-[8px_8px_0_#F5F2EB]">
        {state === "paid" && (
          <p className="inline-block -rotate-2 rounded-md border-2 border-[#F5F2EB] bg-[#FF3B1F] px-4 py-1 text-[10px] font-mono font-semibold uppercase tracking-[0.25em] text-white">
            Sold
          </p>
        )}
        <h1 data-testid="payment-status-text" className="mt-6 font-serif text-4xl font-black uppercase tracking-tight">
          {state === "paid" && "It's yours."}
          {state === "checking" && "Confirming payment…"}
          {state === "pending" && "Almost there"}
          {state === "error" && "Hmm, can't confirm"}
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-[#F5F2EB]/60">
          {state === "paid" && "Payment confirmed — the piece is off the rack for good. JFLY will reach out to arrange shipping."}
          {state === "checking" && "Hold tight, checking with Stripe."}
          {state === "pending" && "Your payment is still processing. It usually clears within a minute."}
          {state === "error" && "We couldn't verify this payment. If you were charged, send us a message and we'll sort it out."}
        </p>
        <Link
          to="/"
          data-testid="payment-back-link"
          className="mt-8 inline-block rounded-full border-2 border-[#F5F2EB] bg-[#FF3B1F] px-8 py-3 text-xs font-mono font-medium uppercase tracking-[0.2em] text-white shadow-[4px_4px_0_#F5F2EB] transition-transform hover:-translate-y-0.5"
        >
          Back to the rack
        </Link>
      </div>
    </div>
  );
}
